"use client";
import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Fade,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Poppins } from "next/font/google";
import { jwtDecode } from "jwt-decode";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import { ContainedButton, CTextButton, CustomFormLabel } from "./CustomStyles";
import PasswordField from "./CustomFields/PasswordField";
import axios from "axios";

import ConfirmPasswordField from "./CustomFields/ConfirmPasswordField";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import { useRouter } from "next/navigation";
import { useCommon } from "../../app/context";
import { apiRequest } from "../../utils/axiosInstance";
import { getUserData } from "../../hooks/HelperFunctions";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const forgotPassButtonStyle = {
  p: 0,
  m: 0,
  height: "1rem",
  width: "fit-content",
  color: "#006A4E",
  justifyContent: "flex-start",
};

const Password = (props) => {
  const {
    email,
    phone,
    signInWith,
    drawerTitle,
    handleClose,
    setAuthSteps,
    handleSubmitFn,
    initializeAgain,
    handleForgotPassFn,
    enrollNowHandler,
    enrollNowTrackTermHandler
  } = props;

  const router = useRouter();

  const {
    enrollNowHandler: enrollNowHandlerFromContext,
    enrollNowTrackTermHandler: enrollNowTrackTermHandlerFromContext
  } = useCommon() || {};


  const [submitted, setSubmitted] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

  // const [password, setPassword] = useState("");
  // const [error, setError] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const isPasswordEmpty = true;

  // * ==== * //

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [error, setError] = useState(false);

  const handlePasswordChange = (newPassword) => {
    setPassword(newPassword);
    if (!newPassword || newPassword.length < 8 || !/\d/.test(newPassword)) {
      setError(true);
    } else {
      setError(false);
    }
  };

  const handleSubmit = () => {
    if (!password || password.length < 8 || !/\d/.test(password)) {
      setError(true);
      return;
    }
    // Proceed with form submission or next step
    console.log("Form submitted with password:", password, 33);
  };

  const getStartedHandler = async () => {
    
    const userInfo = getUserData()

    try {
      const postData = {};
      const response = await apiRequest("/generateLoginCode", "POST", postData);

      const { code } = response;

      if (code) {

        // Construct Become a teacher URL with code
        const appBUrl = `${process.env.NEXT_PUBLIC_BECOME_A_TEACHER_URL}?code=${encodeURIComponent(code)}`;


        window.location.href = appBUrl;
      } else {
        console.error("No code returned from API");
      }

    } catch (error) {
      console.error("Error generating login code:", error);
    }
  }

  //================== google recapcha v3 part start ====================//
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  //================== google recapcha v3 part end ====================//

  const sendPasswordForEmail = () => {
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["password"] = password;
        postData["user_role"] = "student";
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invited_as_teacher"] = props?.invited_as_teacher;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitPasswordForEmailLogin`, postData)
          .then((response) => {
            if (response?.data?.error) {
              setShowLoader(false);
              setAlertSeverity("error");
              setAlertMessage("Sign in failed, Email, password incorrect");
              setAlertOpen(true);
            } else {
              const userData = {
                id: response?.data?.body?.id,
                firstName: response?.data?.body?.firstName,
                lastName: response?.data?.body?.lastName,
                email: response?.data?.body?.email,
                phone_number: response?.data?.body?.phone_number,
                image: response?.data?.body?.image,
                userRole: response?.data?.body?.userRole,
              };
              setErrorStatus(false);
              
              const decoded = jwtDecode(response?.data?.jwt_token);
              localStorage.setItem("token_exp", decoded.exp * 1000);

              // set user data and user access token
              localStorage.setItem("userData", JSON.stringify(userData));
              localStorage.setItem("userToken", response?.data?.token);
              localStorage.setItem("jwtToken", response?.data?.jwt_token);

              // set user as authorized
              localStorage.setItem("userAuthenticated", true);
              const userVerified =
                response?.data?.body?.email_verified_at?.length == 0
                  ? false
                  : true;
              localStorage.setItem("userVerified", userVerified);

              // show success message
              setAlertSeverity("success");
              setAlertMessage("Sign in Success!");
              setAlertOpen(true);

              localStorage.setItem(
                "profile_completed",
                response?.data?.profile_completed
              );
              setShowLoader(false);
              let intention_is_become_a_teacher = sessionStorage.getItem("from_become_a_teacher");

              // console.log(props.organization_invitation, 345);
              if (props.organization_invitation) {
                localStorage.setItem("invite_token", props.invite_token);
                router.push("/create-new-teaching-account");
              } else {
                
                if(intention_is_become_a_teacher == "true"){
                  sessionStorage.removeItem("from_become_a_teacher");
                  getStartedHandler()
                }
                let pendingOperation = localStorage.getItem("pendingOperation") ? localStorage.getItem("pendingOperation") : null
                let pendingOperationType = localStorage.getItem("pendingOperationType") ? localStorage.getItem("pendingOperationType") : null
              
                if(pendingOperation && pendingOperation == "enrollment"){
                  
                  const pendingOperationData = JSON.parse(
                    localStorage.getItem("pendingOperationData")
                  );
                  const userAuthenticated = localStorage.getItem("userAuthenticated");
                  
                  if(pendingOperationType == "track"){
                    if(typeof enrollNowTrackTermHandler == "function"){
                      enrollNowTrackTermHandler(pendingOperationData, userAuthenticated)
                    }else{
                      enrollNowTrackTermHandlerFromContext(pendingOperationData, userAuthenticated)
                    }
                  }else{
                    if(typeof enrollNowHandler == "function"){
                      enrollNowHandler(pendingOperationData, userAuthenticated)
                    }else{
                      enrollNowHandlerFromContext(pendingOperationData, userAuthenticated)
                    }

                  }

                  localStorage.removeItem("pendingOperation")
                  localStorage.removeItem("pendingOperationData")
                }
                initializeAgain()
              }
            }
          })
          .catch((err) => {
            console.log(err);
            setShowLoader(false);
            if (err?.response?.data?.message) {
              setPasswordErrorMessage(err?.response?.data?.message);
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };

  const sendPasswordForMobile = () => {
    let postData = {};
    let fromBecomeATeacher = sessionStorage.getItem("from_become_a_teacher")
    fromBecomeATeacher = fromBecomeATeacher ? Boolean(fromBecomeATeacher) : false 
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["phone"] = `${phone}`;
        postData["from_become_a_teacher"] = fromBecomeATeacher;
        postData["password"] = password;
        postData["user_role"] = "student";
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/submitPasswordForNewPhone`, postData)
          .then((response) => {
            setShowLoader(false);
            if (response?.data?.error) {
              setAlertSeverity("error");
              setAlertMessage("Sign in failed, Email, password incorrect");
              setAlertOpen(true);
            } else {
              console.log(response, "response");
              const userData = {
                id: response?.data?.body?.id,
                firstName: response?.data?.body?.first_name,
                lastName: response?.data?.body?.last_name,
                email: response?.data?.body?.email,
                phone_number: response?.data?.body?.phone_number,
                image: response?.data?.body?.image,
                userRole: response?.data?.body?.user_role,
                from_become_a_teacher : response?.data?.body?.from_become_a_teacher
              };
              setErrorStatus(false);
              sessionStorage.removeItem("from_become_a_teacher");

              const decoded = jwtDecode(response?.data?.jwt_token);
              localStorage.setItem("token_exp", decoded.exp * 1000);

              // set user data and user access token
              localStorage.setItem("userData", JSON.stringify(userData));
              localStorage.setItem("userToken", response?.data?.token);
              localStorage.setItem("jwtToken", response?.data?.jwt_token);

              // set user as authorized
              localStorage.setItem("userAuthenticated", true);
              const userVerified =
                response?.body?.email_verified_at?.length == 0 ? false : true;
              localStorage.setItem("userVerified", userVerified);

              // show success message
              setAlertSeverity("success");
              setAlertMessage("Sign in Success!");
              setAlertOpen(true);

              if (!response?.data?.profile_completed) {
                setAuthSteps(3);
                localStorage.setItem(
                  "profile_completed",
                  response?.profile_completed
                );
              }
              // console.log(props.organization_invitation, 345);
              if (props.organization_invitation) {
                localStorage.setItem("invite_token", props.invite_token);
                router.push("/create-new-teaching-account");
              } else {
                initializeAgain()
              }
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };
  const continueHandler = () => {
    if (password == "") {
      setPasswordError("Password is required");
      return false;
    }
    setShowLoader(true);
    if (signInWith == "email") {
      sendPasswordForEmail();
    } else {
      sendPasswordForMobile();
    }
  };

  const forgotPasswordButtonClickHandler = () => {
    setAuthSteps(5);
  };
  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        {passwordErrorMessage != "" && (
          <Fade in={isPasswordEmpty}>
            <Alert
              severity="warning"
              icon={<InfoOutlinedIcon />}
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#0B132B",
                background: "rgba(239, 117, 49, 0.12)",
                borderRadius: "8px",
                alignItems: "center",
                fontFamily: poppins.style.fontFamily,
              }}
            >
              Incorrect {signInWith == "email" ? "email" : "phone number"} and / or password. <br />
              You can try again or reset your password
            </Alert>
          </Fade>
        )}
        {/* <PasswordField
          placeholder="Password"
          value={password}
          onChange={handlePasswordChange}
          error={error}
          helperText={error ? "Password too short" : ""}
        /> */}
        <Box>
          <CustomFormLabel>Password</CustomFormLabel>
          <ConfirmPasswordField
            placeholder="Enter your password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordError("");
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                continueHandler();
              }
            }}
            error={passwordError != ""}
            helperText={
              passwordError != "" && (
                <span style={{ color: "#BA1A1A" }}>{passwordError}</span>
              )
            }
          />
          {/* <PasswordField
            placeholder="Enter your password"
            value={password}
            onChange={handlePasswordChange}
            error={error}
            helperText={"Password is required"}
          /> */}
        </Box>
        <ContainedButton
          variant="contained"
          fullWidth
          endIcon={<ArrowForwardRoundedIcon />}
          // onClick={handleSubmitFn ? handleSubmitFn : undefined}
          onClick={(e) => continueHandler()}
        >
          Continue
        </ContainedButton>
        <CTextButton
          variant="text"
          sx={{ fontSize: "16px", fontWeight: 500, marginTop: "-4px" }}
          onClick={(e) => forgotPasswordButtonClickHandler()}
        >
          Forgot your password?
        </CTextButton>
      </Box>
      <SimpleBackdrop open={showLoader} />
    </Box>
  );
};

export default Password;
